import { Component } from 'react';

import { getStates } from '~/api/geo';

import Select from 'Lib/components/form/Select';
import withContainer from '../hoc/withContainer';

const mapApiToProps = {
    getStates
};

class StateSelect extends Component {
    state = {
        isLoading: true,
        states: []
    };

    componentDidMount() {
        this.loadData(this.props.countryID);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.countryID != this.props.countryID) {
            this.loadData(this.props.countryID);
        }
    }

    loadData = countryID => {
        this.props.handlePromises([this.props.api.getStates(countryID)]).then(response => {
            this.setState({
                states: response.data,
                isLoading: false
            });
        });
    };

    render() {
        const { value, ...rest } = this.props;
        const { states } = this.state;
        const options = states.map(({ state }) => ({ value: state.stateID, label: `${state.stateID} - ${state.stateName}` }));

        return <Select {...rest} options={options} value={value} />;
    }
}

export default withContainer(StateSelect, mapApiToProps);
